import React, { useState, useEffect } from "react";

const Home = () => {
  const [homepageContent, setHomepageContent] = useState(null);

  useEffect(() => {
    setHomepageContent(
      document.getElementById("userHomepageContent").innerHTML
    );
  }, []);

  // trigger lozad lazy loader after any update
  useEffect(() => {
    // eslint-disable-next-line
    window.lozadObserver && window.lozadObserver.observe();
  });

  return (
    <div>
      <div
        className="pt-3 pb-3"
        dangerouslySetInnerHTML={{ __html: homepageContent }}
      />
    </div>
  );
};

export default Home;
